window.jQuery(function ($) {
  // enable copy button
  new ClipboardJS('.button-copy');

  // move up juno billet section
  $('#juno-bank-slip-thankyou').remove().insertAfter('.woocommerce-thankyou-order-received')
})
